import { render, staticRenderFns } from "./03-MarineNewsAwareness.md?vue&type=template&id=12d828ac&"
import script from "./03-MarineNewsAwareness.md?vue&type=script&lang=js&"
export * from "./03-MarineNewsAwareness.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports